import React, { useEffect, useState } from 'react';
import styles from './Footer.module.css';
import ProfileImages from '../Footer/SocialMedia/ProfileImages';
import { getFooterRes } from "../../loaders/footer";

const Footer = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getFooterRes('/footer', [], []);
        setData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  if(!data) return null;

  return (
    <div className={`${styles.footer} footer`}>
      <div className={styles.footerContent}>
        <h1 className={styles.title}>{data?.description}</h1>
        <div className={styles.links}>
          {data?.contact_links?.map((link, index) => (
            <div key={index} className={index === 0 ? styles.left : styles.right}>
              <h6 className={styles.heading}>{link?.group?.heading}</h6>
              <h2 className={styles.text}>
                <a href={link?.group?.link?.href || '#'} target="_blank" rel="noopener noreferrer">
                  {link?.group?.link?.title}
                </a>
              </h2>
              {link?.group?.social_media && (
                <ProfileImages icons={link.group.social_media} />
              )}
            </div>
          ))}
        </div>
        <p className={styles.copyright}>
          {data?.copyright}
        </p>
      </div>
    </div>
  );
};

export default Footer;